import React from 'react';
import Container from '@material-ui/core/Container';

const AccessDenied = () => {
  return (
    <Container>
      <h1>Access Denied - You do not have permission to access this page</h1>
    </Container>
  );
};

export default AccessDenied;
